<template>
    <div class="main">
        <Titledx text='近一个月专业网格排名统计' />
        <div class="cont">
            <div class="title">
                <span class="source">排名</span>
                <span class="eventTitle">处置部门</span>
                <span class="time">事件处理量</span>
            </div>
            <div class="info">
                <swiper
                    :options="swiperOption"
                    ref="infoSwiper"
                    style="width: 100%; height: 100%"
                    v-if="ifShowSwiper"
                >
                    <swiper-slide
                        v-for="(item, index) in list"
                        :key="index"
                        style="height: 100px"
                    >
                        <div
                            class="box"
                            :style="{ color: item.color ? item.color : '' }"
                        >
                            <span class="source"> <img :src="index==0?first:(index==1?second:(index==2?three:pm))" alt=""> 第{{ index+1 }}名</span>
                            <span class="eventTitle"> <img src="../../assets/dongxiang/rexian.png" alt=""> {{
                                item.name
                            }}</span>
                            <span class="time"> <span style="font-size:30px">{{ item.count }}</span>  <span class="fs">件</span> </span>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>
<script>
import Titledx from "./components/title";
import miment from "miment";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import first from '../../assets/dongxiang/guanjun.png';
import second from '../../assets/dongxiang/yajun.png';
import three from '../../assets/dongxiang/jijun.png';
import pm from '../../assets/dongxiang/shuju.png';

export default {
    components: {
        swiper,
        swiperSlide,
        Titledx,
    },
    data() {
        return { 
           
            first: first,
            second: second,
            three: three,
            pm: pm,
            ifShowSwiper: false,
            swiperOption: {
                autoplay: {
                    delay: 3000,
                },
                direction: "vertical",
                speed: 3000,
                slidesPerView: 12,
                slidesPerGroup: 1,
                loop: true,
            },
            list: [],
            initList: [],
        };
    },
    methods: {

        getToken() {
            let formData = new FormData()
                    formData.append('username', 'dongxiang')
             formData.append('password', 'dxq!@123456@!')
            this.$post(this.urlobj.dx_dl,formData).then(res => {
                localStorage.token = res.newPrimaryKeys.token
                this.$store.commit("updateToken", res.newPrimaryKeys.token);
                this.getData()
            })
        },
        async getData() {
            // let res = await this.$get(this.urlobj.dx_zywg,{
            //     type: 'dxzywgtj'
            // })

            // console.log(res)

            var url = this.urlobj.dx_zywg + "?type=dxzywgtj";
            this.$get(url).then((res) => {
                this.list = res.rows[0]
                this.ifShowSwiper = true;
            });
        }


    },
    created() {
        
    },
    mounted() {
         if(this.$store.state.access_token){
            this.getData();
        }else{
            this.getToken();
        }
        // document.getElementsByClassName("Wg")[0].style.zoom = 0.5;
        // let huanjing = window.location.href.split("//")[1].split("/")[0];
        // console.log(huanjing);
        // window.btnclick = function (type) {
        //     if (type == "goback") {
        //         if (huanjing == "ct.shequyun.cn") {
        //             window.open(
        //                 "https://ceshi.shequyun.cn/#/moduleList",
        //                 "_self"
        //             );
        //         } else {
        //             window.open(`https://${huanjing}/#/moduleList`, "_self");
        //         }
        //     }
        // };
    },
};
</script>
<style lang="less" scoped>
img {
    width: 26px;
    height: 26px;
    margin-right: 18px
}
.main {
    font-size: 27px;
    overflow: hidden;
    .cont {
        height: 799px;
        margin-left: 20px;
        box-sizing: border-box;
        padding: 40px;
        text-align: center;
        .source {
            width: 348px;
        }
        .eventTitle {
            width: 1079px;
        }
        .time,
        .department,
        .status {
            width: 342px;
        }
        .source,
        .eventTitle,
        .time,
        .department,
        .status {
            margin: 0 20px 
            // margin:0;
        }
        .title {
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #18d0ff;
            width: 100%;
            background: rgba(29, 53, 97, 1);
            
            display: flex;
            align-items: center;
            justify-content: space-around;
            height: 64px;

            margin-bottom: 20px;
        }
        .info {
            .swiper-slide /deep/ {
                height: 48px !important;
                margin: 10px 0;
            }
            height: 810px;
            .box {
                width: 100%;
                height: 100%;
                color: #fff;
                font-size: 20px;
                background: rgba(29, 53, 97, 1);
                align-items: center;
                justify-content: space-around;
                span {
                    height: 100%;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                    // justify-content: center;
                }
                .source {
                    padding-left: 92px;
                }
                .eventTitle {
                    padding-left: 400px;
                    font-size: 20px;
                }
                .time {
                    padding-left: 132px;
                    color: rgba(255, 240, 0, 1);
                    
                }
                .source,
                .eventTitle,
                .time,
                .department,
                .status {
                    background: rgba(43, 71, 121, 1);
                    margin: 0 20px
                }
                .fs {
                    font-size: 24px;
                }
            }
        }
    }
}
</style>